import { IntlShape } from 'react-intl';
import { SmartLinkWidgetType } from 'fym-common/src/db/enums';

/**
 * Human name for a block type. IDs are spelled out one by one because the
 * extractor needs them static.
 */
export function getWidgetTypeLabel(intl: IntlShape, type: SmartLinkWidgetType): string {
  switch (type) {
    case SmartLinkWidgetType.info:
      return intl.formatMessage({ id: 'app.widgets.add.info', defaultMessage: 'Text' });
    case SmartLinkWidgetType.image:
      return intl.formatMessage({ id: 'app.widgets.add.image', defaultMessage: 'Image' });
    case SmartLinkWidgetType.link:
      return intl.formatMessage({ id: 'app.widgets.add.link', defaultMessage: 'Link' });
    case SmartLinkWidgetType.player:
      return intl.formatMessage({ id: 'app.widgets.add.player', defaultMessage: 'Player' });
    case SmartLinkWidgetType.socialLinks:
      return intl.formatMessage({ id: 'app.widgets.add.social', defaultMessage: 'Social Media' });
    case SmartLinkWidgetType.profile:
      return intl.formatMessage({ id: 'app.widgets.add.profile', defaultMessage: 'Profile' });
    case SmartLinkWidgetType.presave:
      return intl.formatMessage({ id: 'app.sml.presave.block_label', defaultMessage: 'Catalog links' });
    case SmartLinkWidgetType.media:
      return intl.formatMessage({ id: 'app.sml.smartlinks.blocks.media.name', defaultMessage: 'Media' });
    case SmartLinkWidgetType.presaveSubscribe:
      return intl.formatMessage({
        id: 'app.sml.smartlinks.blocks.presaveSubscribe.name',
        defaultMessage: 'Get every release',
      });
    default:
      return '';
  }
}
